module.exports = __webpack_public_path__ + "img/_ABS9788.2d2ef212.jpg";